import { HiOutlineCash, HiOutlineRefresh, HiOutlineShieldCheck, HiOutlineTruck } from 'react-icons/hi';
import { useTranslation } from 'i18n';
import { formatPrice } from 'utils/formatPrice';
import { deliveryRange } from 'utils/deliveryEstimate';

/** Trust items built ONLY from what the store stated (unset -> hidden). */
export function trustItems(policies, { listingType = 'PHYSICAL', t }) {
  if (!policies) return [];
  const items = [];
  const physical = listingType === 'PHYSICAL';
  const range = physical ? deliveryRange(policies) : null;
  if (range) items.push({ key: 'delivery', Icon: HiOutlineTruck, text: t('trust.delivery', { range }) });
  if (physical && policies.free_shipping_threshold != null) {
    items.push({ key: 'shipping', Icon: HiOutlineTruck, text: t('trust.freeShippingOver', { amount: formatPrice(policies.free_shipping_threshold) }) });
  }
  if (policies.returnable === false) items.push({ key: 'returns', Icon: HiOutlineRefresh, text: t('trust.noReturns') });
  else if (policies.return_days) items.push({ key: 'returns', Icon: HiOutlineRefresh, text: t('trust.returnDays', { count: policies.return_days }) });
  if (policies.warranty_text) items.push({ key: 'warranty', Icon: HiOutlineShieldCheck, text: policies.warranty_text });
  if (physical && policies.cod_available === true) items.push({ key: 'cod', Icon: HiOutlineCash, text: t('trust.cod') });
  return items.slice(0, 4);
}

export default function TrustRow({ policies, listingType }) {
  const { t } = useTranslation();
  const items = trustItems(policies, { listingType, t });
  if (!items.length) return null;
  return (
    <ul className="grid grid-cols-2 gap-2 text-xs text-text sm:grid-cols-4" data-testid="trust-row">
      {items.map(({ key, Icon, text }) => (
        <li key={key} className="flex min-w-0 items-start gap-1.5 rounded-xl border border-border bg-surface p-2" data-testid={`trust-${key}`}>
          <Icon className="mt-0.5 h-4 w-4 shrink-0 text-primary-ink" aria-hidden />
          <span className="min-w-0 break-words">{text}</span>
        </li>
      ))}
    </ul>
  );
}
